
import {defineComponent} from "vue";

export default defineComponent({
  components: { },
  // type inference enabled
});
